import React, { useState } from "react";
import {
  Box,
  Button,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import DocumentSelectorModal from "./DocumentSelectorModal";

export default function RetentionInfo({
  data,
  onChange,
  onDocumentSelected,
  mobile = false,
}) {
  const [open, setOpen] = useState(false);

  const hasDocument = Boolean(data.retencion_documento_sustento_id);

  const handleSelected = (doc, productos) => {
    onChange?.({
      retencion_documento_sustento_id: doc?.id ? String(doc.id) : "",
      retencion_documento_sustento_numero: doc?.numero_documento || doc?.numero || "",
      retencion_documento_sustento_clave: doc?.clave_acceso || "",
      retencion_fecha_documento_sustento: doc?.fecha_emision || "",
      documento_relacionado_id: doc?.id ? String(doc.id) : "",
      documento_relacionado_numero: doc?.numero_documento || doc?.numero || "",
      documento_relacionado_clave_acceso: doc?.clave_acceso || "",
      documento_relacionado_tipo: doc?.tipo_documento || "FACTURA",
      documento_relacionado_fecha: doc?.fecha_emision || "",
    });

    onDocumentSelected?.(doc, productos);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Paper
        sx={{
          p: mobile ? 1.5 : 2,
          border: "1px solid #e0e0e0",
          borderRadius: 2,
          bgcolor: "#fafafa",
        }}
      >
        <Typography sx={{ fontWeight: 800, color: "#333", mb: 1.5 }}>
          Información de retención
        </Typography>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          <Button
            variant="contained"
            onClick={() => setOpen(true)}
            sx={{ bgcolor: "#1565C0", alignSelf: mobile ? "stretch" : "flex-start" }}
          >
            Seleccionar documento sustento
          </Button>

          {hasDocument ? (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <TextField
                label="Documento sustento"
                value={data.retencion_documento_sustento_numero || ""}
                InputProps={{ readOnly: true }}
                fullWidth={mobile}
                sx={{ minWidth: mobile ? "100%" : 350 }}
              />
              <TextField
                label="Clave de acceso"
                value={data.retencion_documento_sustento_clave || ""}
                InputProps={{ readOnly: true }}
                fullWidth
              />
            </Box>
          ) : (
            <Typography sx={{ fontSize: 13, color: "#777" }}>
              Selecciona el documento sobre el que se generará la retención.
            </Typography>
          )}

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: mobile ? "1fr" : "1fr 1fr",
              gap: 1.5,
            }}
          >
            <TextField
              label="Periodo fiscal"
              value={data.retencion_periodo_fiscal || ""}
              onChange={(e) => onChange?.({ retencion_periodo_fiscal: e.target.value })}
              placeholder="MM/YYYY"
              fullWidth
            />

            <TextField
              label="Fecha documento sustento"
              value={data.retencion_fecha_documento_sustento || ""}
              onChange={(e) =>
                onChange?.({ retencion_fecha_documento_sustento: e.target.value })
              }
              placeholder="dd/mm/aaaa"
              inputProps={{ maxLength: 10 }}
              fullWidth
            />
          </Box>
        </Box>
      </Paper>

      <DocumentSelectorModal
        open={open}
        onClose={() => setOpen(false)}
        persona={data.persona}
        title="Seleccionar documento para retención"
        tipo="FACTURA"
        endpoint="/facturas/documentos-relacionados/facturas-cliente/"
        detailEndpoint="/facturas/documentos-relacionados/detalle-factura/"
        onSelected={handleSelected}
      />
    </Box>
  );
}